<template>
  <component v-bind:is="componentName" v-bind:key="`${vendor.category}-vendor-${vendor.id}`" :vendor="vendor"></component>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NormalVendorCard from './NormalVendorCard.vue';
  import PricingVendorCard from './PricingVendorCard.vue';
  import FuelUtilities from "../../utils/FuelUtilities";

  export default {
    name: 'VendorCard',
    mixins: [FuelUtilities],
    components: {
      NormalVendorCard,
      PricingVendorCard,
    },
    props: {
      vendor: Object,
    },
    computed: {
      componentName() {
        return this.vendor.hasPricingGuide ? 'PricingVendorCard' : 'NormalVendorCard';
      },
      description() {
        return this.truncateDescription(this.decode(this.vendor.desc), 65);
      },
      modalData() {
        return { ...this.vendor };
      },
      featured() {
        return (this.vendor.featured === 1 || this.vendor.featured === '1');
      },
      modalKey() {
        return this.featured ? 'featuredVendorModal' : 'vendorModal';
      },
    },
    methods: {
      downloadOverview() {
        if (this.vendor.overviewURL != "") {
          window.location = this.decode(this.vendor.overviewURL);
        }
      },
      truncateDescription(description, length) {
        return description.length > length
          ? this.truncateString(description, length)
          : description;
      },
      truncateString(str, length) {
        return str.substring(0, length - 3) + "...";
      },
      activateModal() {
        this.$store.dispatch('main/showModal', this.modalKey);
        this.$store.dispatch('main/setProperty', { key: 'modalData', value: this.modalData });
      },
    },
  };
</script>
